<template>
  <div class="login">
    <FormLoginWrapper title="Login">
      <q-input
        v-model="$v.email.$model"
        type="email"
        data-cy="login-email"
        :data-error="$v.email.$error"
        label="Email"
        autofocus
        v-bind="inputProps('email')"
        @keyup.enter="login(email, password)"
      >
        <template v-slot:prepend>
          <q-icon v-bind="iconProps('fas fa-user-tie', $v.email.$error)" />
        </template>
      </q-input>

      <q-input
        v-model="$v.password.$model"
        :type="viewPassword ? 'text' : 'password'"
        data-cy="login-password"
        :data-error="$v.password.$error"
        label="Password"
        class="q-mt-sm"
        v-bind="inputProps('password')"
        @keyup.enter="login(email, password)"
      >
        <template v-slot:prepend>
          <q-icon v-bind="iconProps('fas fa-lock-alt', $v.password.$error)" />
        </template>

        <template v-slot:append>
          <q-icon
            v-bind="iconProps('', $v.password.$error)"
            :class="viewPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            class="cursor-pointer"
            @click="viewPassword = !viewPassword"
          />
        </template>
      </q-input>

      <FormLoginLink text="Forgot Password?" @click="goToResetPassword" />

      <q-btn
        :loading="isRequestInProgress"
        rounded
        unelevated
        color="white"
        class="full-width q-mt-lg text-black"
        label="Login"
        data-cy="login-btn"
        @click="login(email, password)"
      />
    </FormLoginWrapper>
  </div>
</template>

<script>
import { validations } from './validations'
import commonProps from '@/reusable/login/commonProps'
// Components
import FormLoginWrapper from '@/reusable/login/FormLoginWrapper'
import FormLoginLink from '@/reusable/login/FormLoginLink'

export default {
  components: {
    FormLoginWrapper,
    FormLoginLink
  },

  mixins: [validations, commonProps],

  data: () => ({
    email: null,
    password: null,
    isRequestInProgress: false,
    viewPassword: false
  }),

  created() {
    this.inputProps = this.getCommonInputProps()
    this.iconProps = this.getCommonIconProps()
  },

  methods: {
    login(email, password) {
      if (!this.$v_validationPass() || this.isRequestInProgress) return
      this.isRequestInProgress = true
      this.$store.dispatch('login', { email, password }).finally(() => (this.isRequestInProgress = false))
    },

    goToResetPassword() {
      let route = { name: 'reset-password' }
      if (this.email) {
        route.query = { email: this.email }
      }
      this.$router.push(route)
    }
  }
}
</script>

<style lang="stylus" scoped>
.login {
  display flex
  justify-content center
  align-items center
  height 100vh
  margin 0
  width 100%
  background-image linear-gradient(135deg, rgba(155,225,171,0.85) 0%,rgba(0,123,255,0.85) 100%), url(../../assets/img/login/login-back.jpg)
  background-repeat no-repeat
  background-size cover
}
</style>
